@app.directive 'saveButton', ->
  restrict: 'E'
  replace: true
  scope: {}
  bindToController:
    saveableType: '@'
    saveableId: '@'
    apiEndpoint: '@'
  controllerAs: 'saveButton'
  controller: ($state, $scope, AnalyticsService, ModalService, $http, localStorageService) ->
    @isSaved = false
    savedId = null

    getHeaderConfig = ->
      userToken = localStorageService.get('user.token')
      {headers: { 'Authorization': 'Bearer ' + userToken, "x-csrf-token":undefined }}

    updateIsSaved = =>
      return if (!@saveableId || !$state.currentUser)

      # TODO: getting all likes for a given activity can be expensive.
      # Should find a better way to check if an activity has been saved.
      url = "#{csConfig.chefstepsEndpoint}/api/v0/#{@apiEndpoint}/#{@saveableId}/likes"
      $http.get(url).then((res) =>
        @isSaved = _.chain(res.data).pluck('userId').includes($state.currentUser?.id).value()
        if @isSaved
          savedId = _.find(res.data, {userId: $state.currentUser.id}).id
      )

    $scope.$watch (=> @saveableId), updateIsSaved

    save = =>
      if !$state.currentUser
        ModalService.open('login', source: 'saveButton')
        return
      url = "#{csConfig.chefstepsEndpoint}/api/v0/likes?likeable_type=#{@saveableType}&likeable_id=#{@saveableId}"
      data = {}
      $http.post(url, data, getHeaderConfig())
        .success((res)=>
          @isSaved = true
          savedId = res.id
          AnalyticsService.track('Liked', {'Activity': @saveableType + "_" + @saveableId})
      )

    unsave = =>
      if !$state.currentUser
        ModalService.open('login', source: 'unsaveButton')
        return
      url = "#{csConfig.chefstepsEndpoint}/api/v0/likes/#{savedId}"
      data = {}
      $http.delete(url, getHeaderConfig())
        .success((res)=>
          @isSaved = false
          AnalyticsService.track('Unliked', {'Activity': @saveableType + "_" + @saveableId})
      )

    @toggleSaved = => if @isSaved then unsave() else save()

    this

  templateUrl: "/assets/templates/directives/saveButton/saveButton.html"
